export default {
    title: "Saludos",
    name: "Nombre",
    password: "Contraseña",
    login: "Logon",
    guest: "Invitado"
}